import {html, nothing, live} from '../lib/lit-html.js';
import {SliderRange} from '../lib/mwc-slider-range.js';
import {formatPrice} from '../utils/formatprice.js';

export function priceFilter(state){
	if (state.priceRange.min >= state.priceRange.max){
		return nothing;
	}

	var minValue = state.search.price.min != null
		? state.search.price.min 
		: state.priceRange.min;

	var maxValue = state.search.price.max != null
		? state.search.price.max 
		: state.priceRange.max;

	var exponent = state.currency.exponent;

	var minAttr = state.priceRange.min * 10 ** exponent;
	var maxAttr = state.priceRange.max * 10 ** exponent;
	var valueStart = Math.round(minValue * 10 ** exponent);
	var valueEnd = Math.round(maxValue * 10 ** exponent)

	return html`
		<div class="ekm-search-page-price-range">
			<div class="ekm-search-page-price-title">Price</div>
			
			<mwc-slider-range
				step="1"
				min=${live(minAttr)}
				max=${live(maxAttr)}
				.valueStart=${live(valueStart)}
				.valueEnd=${live(valueEnd)}>
			</mwc-slider-range>

			<div class="ekm-search-page-price-values">
				<div class="ekm-search-page-price-value">${formatPrice(minValue, state.currency)}</div>
				<div class="ekm-search-page-price-value">${formatPrice(maxValue, state.currency)}</div>
			</div>
		</div>
	`;
}